// extracted by mini-css-extract-plugin
module.exports = {"faq":"frequently-asked-questions_faq__5oIIi","more":"frequently-asked-questions_more__S_HTS"};